import { render, staticRenderFns } from "./ArrowBackIcon.vue?vue&type=template&id=3deb7430&scoped=true&"
import script from "./ArrowBackIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ArrowBackIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb7430",
  null
  
)

export default component.exports